import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import {  useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import { useTranslation } from "react-i18next";
import RegistryForm from "../../Forms/Admin/RegistryForm/RegistryForm";
import { get } from "lodash";

const RegistryModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [folders, setFolders] = useState(get(props,'initialValues.defaultFolders',[]));
  const [statuses, setStatuses] = useState(get(props,'initialValues.availableStatuses',[]));
  const [steps, setSteps] = useState([
    { title: props.header, error: false }
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "RegistryForm";
  const { handleHide, show } = props;

  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          onClick={() => setIsSubmit(true)}
          bmxclass="Success"
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {    
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"700px"}     
      onClose={handleHide}
      header={props.header}
      buttons={buttons()}
      steps={steps}
    >
      <RegistryForm
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        folders={folders}
        statuses={statuses}
        setStatuses={setStatuses}
        setFolders={setFolders}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "registryModal" })(RegistryModal);
